import { ProductReviewInterface } from '@qlevr/shared/interfaces';
import { productReviewMapper } from '@qlevr/shared/mappers';
import { isProduction } from '@qlevr/shared/utilities';

export async function getProductReviews(productId: string, locale: string): Promise<ProductReviewInterface> {
  // Temporarily hardcoding the storeId to NL as requested by the client
  // https://www.notion.so/deardigital/Yotpo-star-reviews-from-dutch-YP-store-a5f9b8b5aac44185a80647a9ad3648a4?pvs=4
  // const storeId = getYotpoKeyByLocale(localUppercase) as string;
  const storeId = process.env['NEXT_PUBLIC_YOTPO_REVIEWS_ACCESS_TOKEN_NL']!;

  try {
    const res = await fetch(getUrl(storeId, productId));
    const isError = res.status !== 200;

    if (isError) {
      if (!isProduction()) {
        console.warn('Review not found for product:', productId, 'URL:', getUrl(storeId, productId));
      }
      // Return a default empty review object instead of calling notFound()
      return {
        totalReview: 0,
        averageScore: 0,
        totalOrganicReviews: 0,
        organicAverageScore: 0,
        totalProductReviews: {
          reviews: [],
          bottomline: {
            star_distribution: {},
          },
        },
      };
    }

    const reviews = await res.json();
    return productReviewMapper(reviews);
  } catch (error) {
    if (!isProduction()) {
      console.error('Error fetching reviews for product:', productId, error);
    }
    // Return a default empty review object on any error
    return {
      totalReview: 0,
      averageScore: 0,
      totalOrganicReviews: 0,
      organicAverageScore: 0,
      totalProductReviews: {
        reviews: [],
        bottomline: {
          star_distribution: {},
        },
      },
    };
  }
}

function getUrl(storeId: string, productId: string): string {
  return `https://api-cdn.yotpo.com/v1/widget/${storeId}/products/${productId}/reviews.json`;
}
